var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-rating-star"
  }, [_c('p', {
    staticClass: "rating-head-tail"
  }, [_vm._v(" " + _vm._s(_vm.props.ratingTemplate.head) + " ")]), _c('div', {
    staticClass: "rating-card"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.TUITranslateService.t("AIDesk.请对本次服务进行评价")))]), _c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticStyle: {
      "max-width": "200px"
    }
  }, _vm._l(_vm.starList, function (item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function ($event) {
          return _vm.setValue(index);
        },
        "mouseenter": function ($event) {
          return _vm.setHoverValue(index);
        },
        "mouseleave": function ($event) {
          return _vm.setHoverValue(-1);
        }
      }
    }, [item === 1 ? _c('Icon', {
      attrs: {
        "src": _vm.star,
        "width": "25px",
        "height": "25px"
      }
    }) : _c('Icon', {
      attrs: {
        "src": _vm.starLine,
        "width": "25px",
        "height": "25px"
      }
    })], 1);
  }), 0)]), _c('div', [_c('div', {
    style: {
      marginTop: 10 + 'px',
      marginBottom: 10 + 'px',
      wordBreak: 'normal'
    }
  }, [_vm._v(" " + _vm._s(_vm.hoverValue === -1 ? _vm.value === -1 ? _vm.TUITranslateService.t("AIDesk.如果满意请给好评哦～") : _vm.desc[_vm.value] : _vm.desc[_vm.hoverValue]) + " ")]), _c('div', {
    staticClass: "hidden-desc"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.如果满意请给好评哦～")) + " ")])]), _c('button', {
    staticClass: "submit-button",
    attrs: {
      "disabled": _vm.hasReply || _vm.hasExpire
    },
    on: {
      "click": _vm.submitRatingStar
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.提交评价")) + " ")])]), _vm.hasReply ? _c('p', {
    staticClass: "rating-head-tail",
    style: {
      marginTop: 20 + 'px'
    }
  }, [_vm._v(" " + _vm._s(_vm.props.ratingTemplate.tail) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }